var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "details" },
    [
      _vm._m(0),
      _c("Table", {
        attrs: {
          items: _vm.addresses,
          attributes: _vm.tableAttributes,
          options: _vm.tableOptions
        },
        on: { edit: _vm.editAddress, head: _vm.addAddress }
      }),
      _vm.isOpen(_vm.modalNames.ADD_ADDRESS)
        ? _c("SupporterAddAddress", { attrs: { supporter: _vm.supporter } })
        : _vm._e(),
      _vm.isOpen(_vm.modalNames.EDIT_ADDRESS)
        ? _c("SupporterEditAddress", {
            attrs: {
              supporter: _vm.supporter,
              canEdit: _vm.canEdit,
              address: _vm.address
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "intro" }, [
      _c("h4", [_vm._v("Addresses")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }